import { render } from "./AdminInactiveEmpList.vue?vue&type=template&id=18d58db1"
import script from "./AdminInactiveEmpList.vue?vue&type=script&lang=js"
export * from "./AdminInactiveEmpList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__